import { isStreamIQ, isToya } from '@/shared/lib'

export const getSearchService = async () => {
    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/features/VOD/lib/searchServiceToya')
            return module.useSearchResultsToya
        } catch (error) {
            console.warn(
                'useSearchResultsToya module is missing. TOYA-specific features are disabled.',
                error
            )
            return null
        }
    }

    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/features/Search/searchServiceStreamIQ')
            return module.useSearchResultsStreamIQ
        } catch (error) {
            console.warn(
                'useSearchResultsStreamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }

    throw new Error('Unknown API type')
}
